import { Injectable, inject } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of, switchMap, throwError } from 'rxjs';
import { delay, tap } from 'rxjs/operators';

import { Logger } from '../services/logger/logger';
import { LOGGER } from '../consts/log.enum';
import { get, isEqual } from 'lodash-es';
import { INTERCEPTOR_SKIP_ALL_HEADER } from '../consts/interceptor';
import { mocks } from '../../mocks';

export const INTERCEPTOR_SKIP_MOCK_HEADER = 'X-Skip-Mock-Interceptor';

@Injectable()
export class HttpRequestMockInterceptor implements HttpInterceptor {
  private logger = inject(Logger);
  private http = inject(HttpClient);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.has(INTERCEPTOR_SKIP_ALL_HEADER)) {
      return next.handle(request); // Пропускаем перехват, если заголовок присутствует
    }

    if (request.headers.has(INTERCEPTOR_SKIP_MOCK_HEADER)) {
      const headers = request.headers.delete(INTERCEPTOR_SKIP_MOCK_HEADER);
      return next.handle(request.clone({ headers }));
    }

    return this.mockHandle(request, next);
  }

  private mockHandle(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    for (const element of mocks) {
      if (request.url !== element.url) {
        continue;
      }

      // есть параметры
      if (element.params) {
        let hasParams = true;

        for (const paramName in element.params) {
          const expectedValue = element.params[paramName];
          const actualValue = get(request.body, paramName);

          if (!isEqual(expectedValue, actualValue)) {
            hasParams = false;
            break;
          }
        }

        if (!hasParams) {
          continue;
        }
      }

      this.logger.log('%cIntercepted mock services call', LOGGER.request, request.url);
      this.logger.log('%cRequest body', LOGGER.request, request.body);

      return this.http
        .get(`/assets/mocks/${element.json}.json`, {
          headers: new HttpHeaders().set(INTERCEPTOR_SKIP_MOCK_HEADER, '').set(INTERCEPTOR_SKIP_ALL_HEADER, ''),
        })
        .pipe(
          delay(500),
          tap((data) => {
            this.logger.log('%cLoaded from json', LOGGER.requestResult, data);
          }),
          switchMap((data) => {
            const httpCode = element.httpCode || 200;
            if (httpCode >= 300) {
              throw new HttpErrorResponse({ status: httpCode, error: data });
            }
            return of(new HttpResponse({ status: element.httpCode || 200, body: data }));
          }),
        );
    }

    return next.handle(request);
  }
}
